/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <div class="container">
        <div class="form-container">
            <div class="left">
                <div class="texto">{{ currentViewTitle }}</div>

                <component :is="activeComponent" @change-view="switchView" class="auth-component" />
            </div>

            <div class="right">
                <img class="logoRight" src="../assets/images/ania-logo.png" alt="Logo" />
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from '@/components/auth/Login.vue';
import RegisterForm from '@/components/auth/Registrar.vue';
import RecoveryForm from '@/components/auth/RecuperarContraseña.vue';

export default {
    name: 'AuthView',
    components: {
        LoginForm,
        RegisterForm,
        RecoveryForm
    },
    data() {
        return {
            currentView: 'login',
        };
    },
    computed: {
        activeComponent() {
            const views = {
                login: 'LoginForm',
                register: 'RegisterForm',
                recovery: 'RecoveryForm'
            };
            return views[this.currentView];
        },
        currentViewTitle() {
            switch (this.currentView) {
                case 'login': return 'Bienvenido/a';
                case 'register': return 'Crear cuenta';
                case 'recovery': return 'Recuperar contraseña';
                default: return 'Acceso';
            }
        }
    },
    methods: {
        switchView(viewName) {
            this.currentView = viewName;
        }
    }
};
</script>

<style scoped>
.container {
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: white;
    box-sizing: border-box;
}

.form-container {
    width: 100%;
    max-width: 420px;
    background: white;
    border-radius: 16px;
    box-shadow: 0px 10px 25px rgb(0 0 0 / 25%);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.left {
    order: 1;
    background: #2a428c;
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    max-height: 100dvh;
    overflow-y: auto;
}

.texto {
    font-size: 26px;
    font-weight: 600;
    text-align: center;
    color: white;
}

.auth-component {
    width: 100%;
    color: white;
}

.right {
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.logoRight {
    width: 65%;
    max-width: 220px;
}

@media (min-width: 820px) {
    .container {
        padding: 40px;
    }

    .form-container {
        max-width: 1200px;
        height: 90vh;
        flex-direction: row;
    }

    .left,
    .right {
        width: 50%;
    }

    .left {
        padding: 40px;
        justify-content: center;
        overflow-y: auto;
    }

    .texto {
        font-size: 36px;
        text-align: left;
    }

    .right {
        padding: 0;
    }

    .logoRight {
        width: 70%;
        max-width: none;
    }
}
</style>
